export default __webpack_public_path__ + "static/media/home1.01a03ef4.jpg";